// extracted by mini-css-extract-plugin
export default {"userSection":"userInfo_userSection__oePez","user":"userInfo_user__kkFWs","user__label":"userInfo_user__label__-MPOX","user__text":"userInfo_user__text__v5hqr"};